import { GlButton, GlModal, GlModalDirective, GlTooltipDirective } from '../../../../../../../node_modules/@gitlab/ui/src/index.js?vue3';
import { BUTTON_TOOLTIP_CANCEL, BUTTON_TOOLTIP_DELETE, BUTTON_TOOLTIP_RETRY } from '~/ci/constants';
import { __ } from '~/locale';
import { DELETE_MODAL_ID } from '../constants';
export default {
    name: 'HeaderActions',
    BUTTON_TOOLTIP_CANCEL,
    BUTTON_TOOLTIP_DELETE,
    BUTTON_TOOLTIP_RETRY,
    modal: {
        id: DELETE_MODAL_ID,
        actionPrimary: {
            text: __('Delete pipeline'),
            attributes: {
                variant: 'danger'
            }
        },
        actionCancel: {
            text: __('Cancel')
        }
    },
    components: {
        GlButton,
        GlModal
    },
    directives: {
        GlModal: GlModalDirective,
        GlTooltip: GlTooltipDirective
    },
    props: {
        pipeline: {
            type: Object,
            required: true
        },
        isRetrying: {
            type: Boolean,
            required: true
        },
        isDeleting: {
            type: Boolean,
            required: true
        },
        isCanceling: {
            type: Boolean,
            required: true
        }
    },
    emits: [
        'cancel-pipeline',
        'delete-pipeline',
        'retry-pipeline'
    ],
    computed: {
        canRetryPipeline () {
            const { retryable, userPermissions } = this.pipeline;
            return retryable && userPermissions.updatePipeline;
        },
        canCancelPipeline () {
            const { cancelable, userPermissions } = this.pipeline;
            return cancelable && userPermissions.cancelPipeline;
        }
    }
};
